const LIBELLES_ORIGINE: Record<string, string> = {
  VERIFIEE_TICKBOSS: "Vérifiée Tickboss",
  IMPORTEE_LIVE: "Importée Live",
  DECLAREE_PRODUCTEUR: "Déclarée par le producteur",
  DECLAREE_STRUCTURE: "Déclarée par une structure",
  CALCULEE: "Calculée"
};

export function libelleOrigine(origine: string): string {
  return LIBELLES_ORIGINE[origine] ?? origine.replaceAll("_", " ");
}

export function formatDate(date: string): string {
  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  }).format(new Date(date));
}

export function valeurListe(
  objet: Record<string, unknown>,
  cle: string
): string[] {
  const valeur = objet[cle];
  return Array.isArray(valeur) ? valeur.map(String) : [];
}
